import { render } from "./data-tables.vue?vue&type=template&id=bafa87d6"
import script from "./data-tables.vue?vue&type=script&lang=js"
export * from "./data-tables.vue?vue&type=script&lang=js"

import "./data-tables.vue?vue&type=style&index=0&id=bafa87d6&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__